import React from "react";

const Keypad = ({ onCodeEntered }) => {
  const [values, setValues] = React.useState([-1, -1, -1, -1, -1]);

  const updatePins = (num) => {
    //console.log("Entered: " + num);
    let enteredCode = [...values];
    let codeComplete = true;
    for (let x = 0; x < 5; x++) {
      if (enteredCode[x] < 0) {
        //console.log("values[x]: " + num);
        enteredCode[x] = num;
        if (x < 4) codeComplete = false;
        break;
      }
    }
    //console.log(enteredCode);
    if (codeComplete) {
      onCodeEntered(enteredCode.join(""));
      setValues([-1, -1, -1, -1, -1]);
    } else {
      setValues(enteredCode);
    }
  };
  const clearPins = () => {
    setValues([-1, -1, -1, -1, -1]);
  };

  return (
    <div className="keypad_container">
      <div className="pin">
        <div className="desc">Enter Passcode</div>
        <div className="digit_row">
          <div className="pincode code1">{values[0] < 0 ? "○" : "●"}</div>
          <div className="pincode code2">{values[1] < 0 ? "○" : "●"}</div>
          <div className="pincode code3">{values[2] < 0 ? "○" : "●"}</div>
          <div className="pincode code4">{values[3] < 0 ? "○" : "●"}</div>
          <div className="pincode code4">{values[4] < 0 ? "○" : "●"}</div>
        </div>
      </div>
      <div className="keypad">
        <div className="digit_row">
          <div className="digit" onClick={() => updatePins(1)}>
            1
          </div>
          <div className="digit" onClick={() => updatePins(2)}>
            2
          </div>
          <div className="digit" onClick={() => updatePins(3)}>
            3
          </div>
        </div>
        <div className="digit_row">
          <div className="digit" onClick={() => updatePins(4)}>
            4
          </div>
          <div className="digit" onClick={() => updatePins(5)}>
            5
          </div>
          <div className="digit" onClick={() => updatePins(6)}>
            6
          </div>
        </div>
        <div className="digit_row">
          <div className="digit" onClick={() => updatePins(7)}>
            7
          </div>
          <div className="digit" onClick={() => updatePins(8)}>
            8
          </div>
          <div className="digit" onClick={() => updatePins(9)}>
            9
          </div>
        </div>
        <div className="digit_row">
          <div className="bottom_left"></div>
          <div className="digit" onClick={() => updatePins(0)}>
            0
          </div>
          <div className="bottom_right" onClick={clearPins}>
            Clear
          </div>
        </div>
      </div>
    </div>
  );
};

export default Keypad;
